const giftcardScript = document.createElement("script");
giftcardScript.src = "https://cdn.jsdelivr.net/npm/flatpickr";
giftcardScript.type = "text/javascript";
giftcardScript.onreadystatechange = handler;
giftcardScript.onload = handler;
document.getElementsByTagName("head")[0].appendChild(giftcardScript);
function handler() {
  const giftCard = {
    version: "1.2",
    shop: "",
    product_id: 0,
    store_currency: "USD",
    store_local: "en-US",
    base_api_url: "",
    friend_data: {
      shop: "",
      name: "",
      email: "",
      message: "",
      session_id: "",
      product_id: 0,
      product_name: "",
      custom_fields: [],
    },
    is_submit: false,
    gift_price: 0,
    gift_card: "",
    json_url: "",
    card_items: [],
    custom_price: false,
    variant_id: 0,
    send_type: "me",
    plan: "free",
    field_items: [],
    gift_card_cache: "",
    session_id: "",
    setting: {
      card_width: 400,
      card_height: 300,
      format_date: "d/m/Y",
    },
    renderGiftCard: function (items, plan) {
      const self = this;
      let html = '<div class="hukify-gift-cards">';
      let i = 0;
      const isLoadMore = items.length > 4;
      for (let item of items) {
        let classItem = "hukify-gift-card-image";
        if (i === 0) {
          classItem += " active";
          self.gift_card = item.image_url;
          self.json_url = item.json_url;
          self.previewGiftCard(
            self.gift_price,
            item.image_url,
            item.json_url,
            plan
          );
        }
        let imageUrl = item.image_url;
        let isMore = "no";
        if (isLoadMore && i === 3) {
          isMore = "yes";
          imageUrl =
            "https://cdn.shopify.com/s/files/1/0702/3286/7040/files/plus.png?v=1717061320";
        }
        html += `<div class="hukify-gift-card">`;
        html += `<img class="${classItem}" id="hukify-gift-card-image-${item.card_id}" card-id="${item.card_id}" src="${imageUrl}" json-url="${item.json_url}" alt="Image" show-more="${isMore}">`;
        html += "</div>";
        if (isLoadMore && i === 3) {
          break;
        }
        i++;
      }
      html += "</div>";
      document.getElementById("gift-card-list").innerHTML = html;
      const giftcardElements = document.querySelectorAll(
        ".hukify-gift-card-image"
      );
      if (giftcardElements) {
        giftcardElements.forEach((giftcardElement) => {
          giftcardElement.addEventListener("click", function (event) {
            giftcardElements.forEach((cardEl) => {
              if (cardEl.classList.contains("active")) {
                cardEl.classList.remove("active");
              }
            });
            let showMore = event.target.getAttribute("show-more");
            if (showMore === "yes") {
              self.showMoreGiftCard();
            } else {
              let cardId = event.target.getAttribute("card-id");
              let imageUrl = event.target.getAttribute("src");
              self.gift_card = imageUrl;
              let jsonUrl = event.target.getAttribute("json-url");
              document
                .getElementById(`hukify-gift-card-image-${cardId}`)
                .classList.add("active");
              self.json_url = jsonUrl;
              self.previewGiftCard(self.gift_price, imageUrl, jsonUrl, plan);
            }
          });
        });
      }
    },
    previewGiftCard: function (price, imageUrl, jsonUrl, plan) {
      console.log("preview gift card ", plan, price);
      if (imageUrl !== "") {
        const self = this;
        // const previewElement = document.getElementById('gift-card-preview');
        let previewHtml =
          '<div class="gift-card-section" id="gift-card-preview">';
        previewHtml += `<img class="card-preview-image" id="design-card-preview-image" src="${imageUrl}" alt="Image" />`;
        previewHtml += `<span class="card-preview-price">${self.formatPrice(
          price
        )}</span>`;
        let translateText = document.getElementById(
          "txt-giftcard-trans-customizecard"
        ).value;
        let isDesignBlock = document.getElementById("btn-enable-customize");
        if (plan === "enterprise" && isDesignBlock !== null) {
          previewHtml += `<a href="#" id="card-preview-edit">${translateText}</a>`;
        }
        previewHtml += "</div>";
        let productPreviewClass = document.getElementById(
          "txt-product-preview-class"
        ).value;
        const mediaElement = document.querySelector(`.${productPreviewClass}`);
        if (mediaElement !== null) {
          mediaElement.innerHTML = previewHtml;
        }
        const btnEnableDesign = document.getElementById("btn-enable-customize");
        if (plan === "enterprise" && btnEnableDesign !== null) {
          let randomKey = self.generateRandomString(10);
          btnEnableDesign.setAttribute("json-url", jsonUrl);
          btnEnableDesign.setAttribute("design-key", randomKey);
          document
            .getElementById("card-preview-edit")
            .addEventListener("click", function (e) {
              console.log("Click and Click");
              if (btnEnableDesign) {
                btnEnableDesign.click();
              }
              e.preventDefault();
            });
        }
      }
    },
    selectCard: function (cardId, price, imageUrl) {
      const self = this;
      let mediaElements = document.querySelectorAll(".product__media");
      if (mediaElements) {
        mediaElements.forEach((mediaElement) => {
          const image = mediaElement.querySelector("img");
          if (image) {
            // console.log(image);
            // image.setAttribute('src', imageUrl)
            if (image.classList.contains("gift-card-image")) {
              image.setAttribute("src", imageUrl);
            } else {
              image.remove();
              const img = document.createElement("img");
              // Set the source (src) attribute of the image
              img.src = imageUrl;
              img.classList.add("gift-card-image");
              // Set the alt attribute of the image (optional)
              img.alt = "Image Description";
              mediaElement.appendChild(img);
            }
          }
        });
      }
    },
    validateForm: function (friendInputs) {
      const self = this;
      const friend = self.friend_data;
      let isVaild = true;
      friendInputs.forEach((friendInput) => {
        let okFiled = true;
        if (!friendInput.classList.contains("required")) {
          return true;
        }
        let value = friendInput.value;
        if (value && value.trim() !== "") {
          if (isVaild && friendInput.name === "email") {
            isVaild = self.validateEmail(value);
            okFiled = isVaild;
          }
        } else {
          okFiled = false;
          isVaild = false;
        }
        if (okFiled) {
          if (friendInput.classList.contains("error")) {
            friendInput.classList.remove("error");
          }
        } else {
          if (!friendInput.classList.contains("error")) {
            friendInput.classList.add("error");
          }
        }
      });
      console.log("is vaild", isVaild);
      return isVaild;
    },
    validateEmail: function (email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },
    getGiftCard: async function () {
      const self = this;
      try {
        let giftcardCache = localStorage.getItem("hukify_giftcard_cache");
        let cacheItem =
          giftcardCache !== null ? JSON.parse(giftcardCache) : null;
        if (cacheItem !== null && cacheItem?.cache === self.gift_card_cache) {
          let cardItems = cacheItem.items.filter(
            (item) => item.product_id === parseInt(self.product_id)
          );
          let giftCardCache = {
            items: cardItems,
            plan: cacheItem.plan,
            setting: cacheItem.setting,
          };
          self.renderGiftCardForm(giftCardCache);
          return;
        }
        const apiPath = `${self.base_api_url}?shop=${self.shop}&product_id=${self.product_id}`;
        const response = await self.getAsncRequest(apiPath, "GET", {}, "json");
        self.renderGiftCardForm(response);
      } catch (error) {
        console.log("something wrong when get gift card " + error.message);
      }
    },
    renderGiftCardForm: function (response) {
      const self = this;
      if (response?.setting) {
        self.setting = response.setting;
      }
      if (response && response?.items?.length && response.items.length > 0) {
        self.catchAdToCartButton(false);
        let carditems = response.items;
        self.card_items = carditems;
        let plan = response.plan;
        const contentTab1 = document.getElementById("send-tab-content-1");
        const contentTab2 = document.getElementById("send-tab-content-2");
        if (plan === "premium" || plan === "enterprise") {
          document.getElementById("gift-card-section-tab").style.display =
            "block";
          document.getElementById("menu-option-tab-item-1").style.display =
            "inline-block";
          document
            .getElementById("menu-option-tab-item-1")
            .classList.add("active");
          document
            .getElementById("menu-option-tab-item-2")
            .classList.remove("active");
          self.send_type = "friend";
          contentTab1.style.display = "block";
          contentTab2.style.display = "none";
        }
        if (plan === "enterprise") {
          document.getElementById(
            "gift-card-amount-item-custom"
          ).style.display = "block";
        }
        self.plan = plan;
        self.selectFistGiftCard(plan);
        self.renderGiftCard(carditems, plan);
        let settingElementW = document.getElementById("txt-gc-setting-w");
        let settingElementH = document.getElementById("txt-gc-setting-h");
        if (settingElementW !== null && settingElementH !== null) {
          settingElementW.value = response.setting.card_width || 400;
          settingElementH.value = response.setting.card_height || 300;
        }
      } else {
        let errorMessageHtml =
          '<p style="gift-card-not-found-message">Gift Cards not found</p>';
        document.getElementById("gift-card-list").innerHTML = errorMessageHtml;
      }
    },
    // Every add-to-cart form on the page: the plain "/cart/add" route plus the
    // locale-prefixed one when the store root is not "/".
    cartForms: function () {
      let selector = 'form[action="/cart/add"]';
      if (Shopify.routes.root !== "/") {
        selector += `, form[action="/${Shopify.locale}/cart/add"]`;
      }
      return document.querySelectorAll(selector);
    },
    catchAdToCartButton: function (enable) {
      const self = this;
      self.cartForms().forEach((form) => {
        let button = form.querySelector("button");
        if (button) {
          button.disabled = !enable;
          // This method runs on every validation pass; bind the click handler once.
          if (!button.hasAttribute("data-hukify-bound")) {
            button.setAttribute("data-hukify-bound", "1");
            button.addEventListener("click", function () {
              console.log("reset session");
              self.session_id = self.generateRandomString(10);
              self.resetForm(button);
            });
          }
        }
      });
    },
    // Hidden property inputs this script adds to the cart form carry this marker so
    // they can be removed before the next pass (mode switch, amount change, edit).
    // Without that, inputs from an earlier state stay in the form and get submitted.
    cartPropMarker: "data-hukify-cart-prop",
    clearCartProperties: function () {
      document
        .querySelectorAll(`input[${this.cartPropMarker}]`)
        .forEach((input) => input.remove());
    },
    appendCartProperty: function (form, name, value) {
      let input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[${name}]`;
      input.value = value === undefined || value === null ? "" : value;
      input.setAttribute(this.cartPropMarker, "1");
      form.appendChild(input);
    },
    // Line-item properties for the current mode.
    // "me": Gift Card (Hukify session), Sender name, Message to recipient, custom fields.
    // "friend": Gift Card, Sender name, custom fields, then the recipient under
    // Shopify's native gift card recipient keys (Recipient name, Recipient email,
    // Message) plus the flag that makes Shopify issue the card to the recipient and
    // email it to them; the buyer gets the Gift card receipt notification.
    appendCartProperties: function (sessionId, customFieds) {
      const self = this;
      const isFriend = self.send_type === "friend";
      const friend = self.friend_data;
      self.clearCartProperties();
      self.cartForms().forEach((form) => {
        self.appendCartProperty(form, "Gift Card", sessionId);
        for (let filed of self.field_items) {
          let filedName = filed.name;
          if (filedName === "name" || filedName === "email") {
            // No recipient in "me" mode; "friend" mode sends these under the native keys below.
            continue;
          }
          if (isFriend && filedName === "message") {
            // "friend" mode sends the message under the native "Message" key below.
            continue;
          }
          let value = friend[filedName];
          if (filedName.indexOf("custom_") > -1) {
            let customValue = customFieds.find(
              (item) => item.name === filedName
            );
            value = customValue ? customValue.value : "";
          }
          self.appendCartProperty(form, filed.title, value);
        }
        if (isFriend) {
          // Shopify limits: recipient name 255 characters, message 200.
          let recipientName = String(friend.name || "").trim().slice(0, 255);
          let recipientEmail = String(friend.email || "").trim();
          let message = String(friend.message || "").trim().slice(0, 200);
          self.appendCartProperty(form, "Recipient name", recipientName);
          self.appendCartProperty(form, "Recipient email", recipientEmail);
          if (message !== "") {
            self.appendCartProperty(form, "Message", message);
          }
          self.appendCartProperty(
            form,
            "__shopify_send_gift_card_to_recipient",
            "true"
          );
        }
      });
    },
    // Re-check the active form (friend or me) after a mode switch or amount change:
    // drop the inputs added for the previous state and disable add-to-cart. Then, if
    // every required field has a value, run the full validation (which flags a bad
    // email) and, when valid, re-send to Hukify so the cart inputs match the current
    // mode and amount. Fields the shopper has not reached yet are left unflagged.
    revalidateActiveForm: function () {
      const self = this;
      self.clearCartProperties();
      self.catchAdToCartButton(false);
      const inputs =
        self.send_type === "me"
          ? document.querySelectorAll(".hukify-input-card-me")
          : document.querySelectorAll(".hukify-input-card");
      if (inputs.length === 0) {
        return;
      }
      let filled = true;
      inputs.forEach((input) => {
        let key = input.name;
        if (key) {
          // Both forms reuse field names (sender_name, message), so read the
          // active form's current values rather than whichever form changed last.
          let value = input.value;
          if (key.indexOf("custom_") > -1) {
            let customFiled = self.field_items.find((item) => item.name === key);
            if (customFiled && customFiled.type === "multiple") {
              value = self.getSelectValues(input);
            }
          }
          self.friend_data = { ...self.friend_data, [key]: value };
        }
        if (
          input.classList.contains("required") &&
          (!input.value || input.value.trim() === "")
        ) {
          filled = false;
        }
      });
      if (filled && self.validateForm(inputs)) {
        self.sendCardToFriend();
      }
    },
    sendCardToFriend: async function () {
      const self = this;
      try {
        const apiPath = self.base_api_url + "/sendcard";
        const sessionId = self.session_id;
        let friendData = self.friend_data;
        let currencyRate = Shopify?.currency?.rate
          ? parseFloat(Shopify.currency.rate)
          : 1;
        // console.log(currencyRate);
        let customFieds = [];
        for (let key in friendData) {
          if (
            [
              "shop",
              "session_id",
              "product_id",
              "product_name",
              "custom_fields",
            ].includes(key)
          ) {
            continue;
          }
          if (key.indexOf("custom_") > -1) {
            let customFied = self.field_items.find((item) => item.name === key);
            if (!customFied) {
              continue;
            }
            if (customFied.type === "multiple" && friendData[key].length > 0) {
              let multipleValue = friendData[key];
              let optionValue = customFied.options.filter((item) =>
                multipleValue.includes(item.value)
              );
              let optionLabel = optionValue
                .map((item) => item.label)
                .join(", ");
              customFieds.push({
                title: customFied.title,
                value: optionLabel,
                name: key,
              });
            } else if (customFied.type === "dropdown") {
              if (friendData[key] !== "") {
                let option = customFied.options.find(
                  (item) => item.value === friendData[key]
                );
                customFieds.push({
                  title: customFied.title,
                  value: option.label,
                  name: key,
                });
              }
            } else {
              customFieds.push({
                title: customFied.title,
                value: friendData[key],
                name: key,
              });
            }
          }
        }
        // console.log(customFieds);
        let giftAmount = self.gift_price;
        if (self.custom_price) {
          giftAmount = self.gift_price / currencyRate;
        }
        const postData = {
          ...self.friend_data,
          product_id: self.product_id,
          custom_fields: customFieds,
          session_id: sessionId,
          gift_card: self.gift_card,
          gift_price: giftAmount,
          variant_id: self.variant_id,
          custom_price: self.custom_price ? "yes" : "no",
          send_type: self.send_type,
          language: Shopify.locale,
        };
        self.catchAdToCartButton(false);
        const response = await self.getAsncRequest(
          apiPath,
          "POST",
          postData,
          "json"
        );
        if (response && response?.status && response.status === "success") {
          let localCustomAmounts = localStorage.getItem("huk_custom_amounts");
          if (localCustomAmounts !== null) {
            localCustomAmounts = JSON.parse(localCustomAmounts);
          } else {
            localCustomAmounts = [];
          }
          let isExists = localCustomAmounts.find(
            (item) => item.card_session === sessionId
          );
          if (!isExists) {
            console.log("ADD DRAFT");
            localCustomAmounts.push({
              card_session: sessionId,
              amount_id: 0,
              product_id: self.product_id,
            });
            localStorage.setItem(
              "huk_custom_amounts",
              JSON.stringify(localCustomAmounts)
            );
          }

          // Replace whatever was appended before, then enable add-to-cart.
          self.appendCartProperties(sessionId, customFieds);
          self.catchAdToCartButton(true);
        }
      } catch (error) {
        console.log("error when adding to cart" + error.message);
      }
    },
    generateRandomString: function (length) {
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
      }
      return result;
    },
    showMoreGiftCard: function () {
      const self = this;
      var modal = document.getElementById("hukify-gift-card-modal");
      modal.style.display = "block";
      var span = document.getElementsByClassName("hukify-close")[0];
      span.onclick = function () {
        modal.style.display = "none";
      };
      window.onclick = function (event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      };
      html = "";
      for (let item of self.card_items) {
        html += `<div class="hukify-modal-card">`;
        html += `<img class="hukify-modal-image-card" id="hukify-modal-image-card-${item.card_id}" card-id="${item.card_id}" src="${item.image_url}" json-url="${item.json_url}" alt="Image">`;
        html += "</div>";
      }
      html += '<div class="gc-clea">&nbsp;</div>';
      document.getElementById("huk-modal-gift-cards").innerHTML = html;
      const gitcardsEl = document.querySelectorAll(".hukify-modal-image-card");
      if (gitcardsEl) {
        gitcardsEl.forEach((gitcardEl) => {
          gitcardEl.addEventListener("click", function (event) {
            let imageUrl = event.target.getAttribute("src");
            let jsonUrl = event.target.getAttribute("json-url");
            self.json_url = jsonUrl;
            self.gift_card = imageUrl;
            self.previewGiftCard(self.gift_price, imageUrl, jsonUrl, self.plan);
            modal.style.display = "none";
          });
        });
      }
    },
    formatPrice: function (num) {
      const self = this;
      const currency = Shopify.currency.active;
      const storeLocal = Shopify.locale;
      const formatter = new Intl.NumberFormat(storeLocal, {
        style: "currency",
        currency: currency,
      });
      return formatter.format(num);
    },
    selectFistGiftCard: function (plan) {
      // console.log("SELECT CARD", plan);
      const self = this;
      const giftAmountElements = document.querySelectorAll(
        ".gift-card-amount-item"
      );
      if (giftAmountElements && giftAmountElements.length > 0) {
        const firstgiftAmountElement = giftAmountElements[0];
        let firstPrice = firstgiftAmountElement.getAttribute("price");
        let firstCardId = firstgiftAmountElement.getAttribute("card-id");
        firstPrice = parseInt(firstPrice);
        firstPrice = firstPrice / 100;
        self.gift_price = firstPrice;
        self.variant_id = firstCardId;
        // add variant to to select vaue
         document.getElementById(`productSelect-product-template-gift-certificate`).value = firstCardId;
        document
          .getElementById(`gift-card-amount-item-${firstCardId}`)
          .classList.add("active");
        giftAmountElements.forEach((giftAmountElement) => {
          giftAmountElement.addEventListener("click", function (event) {
            if (event.target.getAttribute("title") === null) {
              return false;
            }
            if (event.target.getAttribute("title") === "customprice") {
              return false;
            }
            document.getElementById("custom-price-content").style.display =
              "none";
            document
              .getElementById("btn-custom-price")
              .setAttribute("is-show", "no");
            document
              .getElementById("gift-card-amount-item-custom")
              .classList.remove("active");
            giftAmountElements.forEach((giftAmountElement2) => {
              if (giftAmountElement2.classList.contains("active")) {
                giftAmountElement2.classList.remove("active");
              }
            });
            let price = event.target.getAttribute("price");
            let cardId = event.target.getAttribute("card-id");
            if (
              document.getElementById(`gift-card-amount-item-${cardId}`) !==
              null
            ) {
              document
                .getElementById(`gift-card-amount-item-${cardId}`)
                .classList.add("active");
            }
            price = parseInt(price);
            price = price / 100;
            self.gift_price = price;
            self.custom_price = false;
            self.variant_id = cardId;
            document.getElementById(`productSelect-product-template-gift-certificate`).value = cardId;
            let inputPrices = document.querySelectorAll('input[name="id"]');
            if (inputPrices && inputPrices.length > 0) {
              inputPrices.forEach(function (inputPrice) {
                inputPrice.value = cardId;
              });
            }
            // console.log("Preview....", price, self.gift_card,self.json_url, plan)
            self.previewGiftCard(price, self.gift_card, self.json_url, plan);
            // Re-send with the new amount if the active form is complete; otherwise
            // keep add-to-cart disabled. (The old selectors here were missing their
            // leading dots, matched nothing, and let an empty form pass validation.)
            self.revalidateActiveForm();
          });
        });
      }
    },
    getForm: async function () {
      const self = this;
      let formCache = localStorage.getItem(
        `hukify_giftcard_form_${Shopify.locale}`
      );
      let fontItem = formCache !== null ? JSON.parse(formCache) : null;
      if (fontItem !== null && fontItem?.cache === self.gift_card_cache) {
        self.field_items = fontItem.field_items;
      } else {
        const apiPath = `${self.base_api_url}/form?shop=${Shopify.shop}&language=${Shopify.locale}`;
        const response = await self.getAsncRequest(apiPath, "GET", {}, "json");
        if (response) {
          self.field_items = response;
        }
        let newCahe = {
          field_items: response,
          cache: self.gift_card_cache,
        };
        localStorage.setItem("hukify_giftcard_form", JSON.stringify(newCahe));
      }
    },
    getFormHtml: async function () {
      const self = this;
      const apiPath = `${self.base_api_url}/constomform?shop=${Shopify.shop}&language=${Shopify.locale}`;
      const formFriendElements = document.getElementById("send-tab-content-1");

      let formFriendCache = localStorage.getItem(
        `hukify_giftcard_formfriend_${Shopify.locale}`
      );
      let formFriendItem =
        formFriendCache !== null ? JSON.parse(formFriendCache) : null;
      if (
        formFriendItem !== null &&
        formFriendItem.cache === self.gift_card_cache
      ) {
        if (formFriendItem.formhtml !== "") {
          formFriendElements.innerHTML = formFriendItem.formhtml;
          const cardInputs = document.querySelectorAll(".hukify-input-card");
          self.catchFriendInput(cardInputs, "friend");
        }
      } else {
        const response = await self.getAsncRequest(
          `${apiPath}&type=friend`,
          "GET",
          {},
          "text"
        );
        if (response !== "") {
          formFriendElements.innerHTML = response;
          const cardInputs = document.querySelectorAll(".hukify-input-card");
          self.catchFriendInput(cardInputs, "friend");
        }
        let newFormFriend = {
          formhtml: response,
          cache: self.gift_card_cache,
        };
        localStorage.setItem(
          `hukify_giftcard_formfriend_${Shopify.locale}`,
          JSON.stringify(newFormFriend)
        );
      }
      // form me
      const formMeElements = document.getElementById("send-tab-content-2");
      let formMeCache = localStorage.getItem(
        `hukify_giftcard_formme_${Shopify.locale}`
      );
      let formMeItem = formMeCache !== null ? JSON.parse(formMeCache) : null;
      if (formMeItem !== null && formMeItem.cache === self.gift_card_cache) {
        if (formMeItem.formhtml !== "") {
          formMeElements.innerHTML = formMeItem.formhtml;
          const cardMeInputs = document.querySelectorAll(
            ".hukify-input-card-me"
          );
          self.catchFriendInput(cardMeInputs, "me");
        }
      } else {
        const responseFormMe = await self.getAsncRequest(
          `${apiPath}&type=me`,
          "GET",
          "text"
        );
        if (responseFormMe !== "") {
          formMeElements.innerHTML = responseFormMe;
          const cardMeInputs = document.querySelectorAll(
            ".hukify-input-card-me"
          );
          self.catchFriendInput(cardMeInputs, "me");
        }
        let newFormMe = {
          formhtml: responseFormMe,
          cache: self.gift_card_cache,
        };
        localStorage.setItem(
          `hukify_giftcard_formme_${Shopify.locale}`,
          JSON.stringify(newFormMe)
        );
      }
    },
    catchFriendInput: function (cardInputs) {
      const self = this;
      console.log("catchFriendInput");
      let friendData = self.friend_data;
      cardInputs.forEach((cardInput) => {
        let inputId = cardInput.getAttribute("id");
        // Friend-mode recipient fields feed Shopify's native gift card recipient,
        // which caps the name at 255 characters and the message at 200.
        if (cardInput.classList.contains("hukify-input-card")) {
          if (cardInput.name === "name") {
            cardInput.setAttribute("maxlength", "255");
          } else if (cardInput.name === "message") {
            cardInput.setAttribute("maxlength", "200");
          }
        }
        if (cardInput.classList.contains("hukify-input-card-date")) {
          let formatDate = self.setting?.format_date
            ? self.setting.format_date
            : "d/m/Y";
          console.log("check input date", inputId);
          flatpickr(`#${inputId}`, {
            dateFormat: formatDate,
            enableTime: formatDate.indexOf("H:i") > -1,
          });
        }
        cardInput.addEventListener("change", function (event) {
          let value = event.target.value;
          let key = event.target.name;
          if (key.indexOf("custom_") > -1) {
            let customFiled = self.field_items.find(
              (item) => item.name === key
            );
            if (customFiled) {
              if (customFiled.type === "multiple") {
                let selectEL =
                  self.send_type === "friend"
                    ? document.getElementById(`friend-${key}`)
                    : document.getElementById(`friend-me-${key}`);
                value = self.getSelectValues(selectEL);
              }
              friendData = {
                ...friendData,
                [key]: value,
              };
            }
          } else {
            friendData = {
              ...friendData,
              [key]: value,
            };
          }
          self.friend_data = friendData;
          let isVaild = self.validateForm(cardInputs);
          if (isVaild) {
            self.sendCardToFriend();
          } else {
            // Drop inputs from the last valid state so they can't ride along later.
            self.clearCartProperties();
            self.catchAdToCartButton(false);
          }
        });
      });
    },
    getSelectValues: function (select) {
      var result = [];
      var options = select && select.options;
      var opt;

      for (var i = 0, iLen = options.length; i < iLen; i++) {
        opt = options[i];

        if (opt.selected) {
          result.push(opt.value || opt.text);
        }
      }
      return result;
    },
    createCustomAmount: async function (price) {
      const self = this;
      try {
        let postData = {
          shop: Shopify.shop,
          product_id: self.product_id,
          price: price,
          amount_id: 0,
        };
        const apiUrl = `${self.base_api_url}/customamount`;
        let localCustomAmounts = localStorage.getItem("huk_custom_amounts");
        if (localCustomAmounts !== null) {
          localCustomAmounts = JSON.parse(localCustomAmounts);
        } else {
          localCustomAmounts = [];
        }
        let currentCustomAmount = localCustomAmounts.find(
          (item) => item.card_session === self.session_id
        );
        if (currentCustomAmount) {
          postData = {
            ...postData,
            amount_id: currentCustomAmount.amount_id,
          };
        }
        const response = await self.getAsncRequest(
          apiUrl,
          "POST",
          postData,
          "json"
        );
        if (response?.amount_id && response.amount_id !== 0) {
          self.variant_id = response.amount_id;
          let newOption = document.createElement("option");
          newOption.setAttribute("data-sku", "");
          newOption.value = response.amount_id;
          newOption.textContent = response.amount_id;
          document.getElementById('productSelect-product-template-gift-certificate').appendChild(newOption);
          document.getElementById(`productSelect-product-template-gift-certificate`).value = response.amount_id;
          const idElements = document.querySelectorAll('input[name="id"]');
          if (idElements) {
            idElements.forEach((idElement) => {
              idElement.value = response.amount_id;
            });
          }
          // update price if avai form (same selector fix as the amount click handler)
          self.revalidateActiveForm();
          // save to local store
          console.log("CURRENT ITEM", currentCustomAmount);
          if (currentCustomAmount) {
            localCustomAmounts = localCustomAmounts.map((item) => {
              if (self.session_id === item.card_session) {
                console.log("FOUDN ITEM");
                return {
                  ...item,
                  amount_id: response.amount_id,
                  product_id: self.product_id,
                };
              } else {
                console.log("NOT FOUND ITEM");
                return item;
              }
            });
          } else {
            let newCustomAmount = {
              card_session: self.session_id,
              amount_id: response.amount_id,
              product_id: self.product_id,
            };
            localCustomAmounts.push(newCustomAmount);
          }
          console.log(localCustomAmounts);
          localStorage.setItem(
            "huk_custom_amounts",
            JSON.stringify(localCustomAmounts)
          );
        }
      } catch (error) {}
    },
    getAsncRequest: function (url, method, data, responseType) {
      let requestOptions = {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
      };
      if (method === "POST" || method === "PUT") {
        requestOptions = {
          ...requestOptions,
          body: JSON.stringify(data),
        };
      }
      return new Promise((resolve, reject) => {
        fetch(url, requestOptions)
          .then((response) => {
            if (!response.ok) {
              reject(response);
            }
            return responseType === "json" ? response.json() : response.text();
          })
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    capitalizeFirstLetter: function (e) {
      return e.charAt(0).toUpperCase() + e.slice(1);
    },
    resetForm: function (button) {
      const self = this;
      setTimeout(function () {
        let friendInputs = document.querySelectorAll(".hukify-input-card");
        let meInputs = document.querySelectorAll(".hukify-input-card-me");
        friendInputs.forEach((friendInput) => {
          friendInput.value = "";
        });
        meInputs.forEach((meInput) => {
          meInput.value = "";
        });
        self.clearCartProperties();
        button.disabled = true;
      }, 2000);
    },
    initData: function () {
      const self = this;
      self.session_id = self.generateRandomString(10);
      self.base_api_url = "/apps/customcards/cards";
      self.product_id = document.getElementById(
        "txt-giftcard-prodouct-id"
      ).value;
      self.shop = Shopify.shop;
      self.store_currency = document.getElementById(
        "txt-simple-store-currency"
      ).value;
      let storeLocal = document.getElementById("txt-simple-store-local").value;
      self.store_local = `${storeLocal}-${self.capitalizeFirstLetter(
        storeLocal
      )}`;
      self.gift_card_cache = document.getElementById(
        "txt-gift-card-cache"
      ).value;
    },
    init: function () {
      const self = this;
      self.initData();
      console.log("gift card v1");
      const amountElements = document.querySelectorAll(
        ".gift-card-amount-item"
      );
      if (amountElements) {
        amountElements.forEach((amountElement) => {
          let title = amountElement.getAttribute("title");
          if (title.indexOf("custom_") > -1) {
            amountElement.style.display = "none";
          }
        });
      }
      /*  self.selectFistGiftCard(); */
      self.getGiftCard();
      let productId = document.getElementById("txt-giftcard-prodouct-id").value;
      let productName = document.getElementById(
        "txt-giftcard-prodouct-name"
      ).value;
      self.friend_data = {
        ...self.friend_data,
        product_id: productId,
        product_name: productName,
        shop: self.shop,
      };
      self.getForm();
      self.getFormHtml();
      /* update preivew  */
      document
        .getElementById("btn-update-preview")
        .addEventListener("click", function (event) {
          let imageUrl = event.target.getAttribute("image-url");
          self.gift_card = imageUrl;
          self.previewGiftCard(self.gift_price, imageUrl, self.plan);
        });
      /* show tab  */
      const menuTab1 = document.getElementById("menu-option-tab-1");
      const menuTab2 = document.getElementById("menu-option-tab-2");
      const contentTab1 = document.getElementById("send-tab-content-1");
      const contentTab2 = document.getElementById("send-tab-content-2");
      // Switching modes re-evaluates the form: inputs appended for the other mode are
      // removed, add-to-cart is disabled, and the newly active form is re-sent only
      // once it is complete. Otherwise a friend's details could ride along on a
      // "send it to me" purchase, or the reverse.
      menuTab1.addEventListener("click", function (event) {
        menuTab1.parentElement.classList.add("active");
        menuTab2.parentElement.classList.remove("active");
        contentTab1.style.display = "block";
        contentTab2.style.display = "none";
        self.send_type = "friend";
        self.revalidateActiveForm();
        event.preventDefault();
      });
      menuTab2.addEventListener("click", function (event) {
        menuTab1.parentElement.classList.remove("active");
        menuTab2.parentElement.classList.add("active");
        contentTab1.style.display = "none";
        contentTab2.style.display = "block";
        self.send_type = "me";
        self.revalidateActiveForm();
        event.preventDefault();
      });
      /* Cusotom price */
      const btnCustomPrice = document.getElementById("btn-custom-price");
      const customPriceEl = document.getElementById("custom-price-content");
      const txtCustomPrice = document.getElementById("txt-custom-price");
      const giftAmountEls = document.querySelectorAll(".gift-card-amount-item");
      btnCustomPrice.addEventListener("click", function (event) {
        let isShow = event.target.getAttribute("is-show") === "yes";
        if (!isShow) {
          customPriceEl.style.display = "block";
          btnCustomPrice.setAttribute("is-show", "yes");
          let customPrice = txtCustomPrice.value;
          if (customPrice && customPrice !== null && !isNaN(customPrice)) {
            customPrice = parseInt(customPrice);
          } else {
            customPrice = 0;
          }
          // console.log("is Show", isShow);
          self.gift_price = customPrice;
          self.previewGiftCard(
            customPrice,
            self.gift_card,
            self.json_url,
            self.plan
          );
          giftAmountEls.forEach((giftAmountEl) => {
            if (giftAmountEl.classList.contains("active")) {
              giftAmountEl.classList.remove("active");
            }
          });
          document
            .getElementById("gift-card-amount-item-custom")
            .classList.add("active");
        }
      });
      txtCustomPrice.addEventListener("change", function (event) {
        let value = event.target.value;
        self.gift_price = parseInt(value);
        self.custom_price = true;
        self.variant_id = 0;
        self.previewGiftCard(value, self.gift_card, self.json_url, self.plan);
        self.createCustomAmount(value);
      });
    },
  };
  giftCard.init();
}
